import {catchError} from 'rxjs/operators';
import {combineEpics} from 'redux-observable';

import * as authEpics from './authEpics';
import * as inactivityEpics from './inactivityEpics';
import * as analyticsEpics from './analyticsEpics';

const modules = [
  authEpics,
  analyticsEpics,
  inactivityEpics,
];

const epics = (_modules = modules) => (
  modules.reduce((acc, module) => [
    ...acc,
    ...Object.values(module),
  ], [])
);

// https://redux-observable.js.org/docs/basics/SettingUpTheMiddleware.html
const rootEpic = function rootEpic(action$, store$, dependencies) {
  return combineEpics(...epics())(action$, store$, dependencies).pipe(
    catchError((error, source) => {
      console.error(error);
      return source;
    })
  );
}

export default rootEpic;
